import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/gross-profit-calculator',
  component: () => import('../../routes/GrossProfitCalculator.svelte'),
  card: {
    id: 'gross-profit-calculator',
    title: 'Gross Profit Calculator',
    description: 'Calculate gross profit and margin from revenue and cost of goods sold. Understand your profitability at a glance.',
    icon: 'attach_money',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/gross-profit-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Gross Profit Calculator – Revenue, COGS & Margin',
    description: 'Free gross profit calculator: enter revenue and cost of goods sold to find gross profit, margin percentage, and profitability. Includes sensitivity table and common industry benchmarks.',
  },
};

export default meta;